import { Attachment } from 'src/app/core/models/attachment.model';
import { UploadService } from 'src/app/core/services/upload.service';
import { ChangeDetectionStrategy, Component, forwardRef, OnDestroy, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-profile-picture',
  templateUrl: './profile-picture.component.html',
  styleUrls: ['./profile-picture.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ProfilePictureComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProfilePictureComponent implements OnInit, OnDestroy, ControlValueAccessor {

  profilePicture$ = new BehaviorSubject<Attachment | null>(null);
  cabinetBasePath$ = this.uploadService.cabinetBasePath$;

  constructor(
  private uploadService: UploadService
  ) { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void { }

  writeValue(obj: Attachment): void {
    this.profilePicture$.next(obj);
  }

  onChange = (_) => { };

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  uploadFiles(files: File[]) {
    this.cabinetBasePath$.pipe(
      take(1)
    ).subscribe(basePath => {
      const mappedFiles = [...files].map(file => {
        return { path: `${basePath}/ProfilePictures/${Date.now()}-${file.name}`, file };
      });
      this.profilePicture$.next(mappedFiles[0]);
    });
  }

}
